import React, { useState, useEffect } from "react";
import api from "../../../../../../core/services/api";
import moment from "moment";
import { useStyles } from "./styles";

//@material-ui
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

//datepicker
import ptBRLocale from "date-fns/locale/pt-BR";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { KeyboardDatePicker } from "@material-ui/pickers";
import { fcaTheme } from "./styles";
import { ThemeProvider } from "@material-ui/styles";

//custom components
import GraphCard from "./GraphCard";

function CuboXTurno(props) {
  const classes = useStyles();
  const [state, setState] = useState({
    start_day: moment().format("YYYY-MM-DD"),
    end_day: moment().add(1, "days").format("YYYY-MM-DD"),
    shifts_list: [],
    shifts_id: null,
    legends: [],
    cube_shift: [
      {
        name: "Presenteísmo",
        type: "column",
        data: [],
      },
      {
        name: "Hora Direta",
        type: "column",
        data: [],
      },
      {
        name: "Efetividade",
        type: "column",
        data: [],
      },
      {
        name: "Cubo",
        type: "line",
        data: [],
      },
    ],
  });

  useEffect(() => {
    getData();
  }, [state.start_day]);

  async function getData() {
    try {
      //const data = await api.get(`cube-shift?start_day=${state.start_day}&end_day=${state.end_day}`);
      const data = await api.get(
        `hdtime-day?start_day=${state.start_day}&end_day=${state.end_day}`
      );
      const data2 = await api.get(`routes`);
      let legends = [];
      let pres_prev = [];
      let efet_prev = [];
      let efet_real = [];
      let series = [
        {
          name: "Presenteísmo",
          type: "column",
          data: [],
        },
        {
          name: "Hora Direta",
          type: "column",
          data: [],
        },
        {
          name: "Efetividade",
          type: "column",
          data: [],
        },
        {
          name: "Cubo",
          type: "line",
          data: [],
        },
        {
          name: "Target",
          type: "line",
          data: [],
        },
      ];
      data.data.forEach((item, index) => {
        let exist = legends.includes(item.shift);
        if (!exist) {
          legends.push(item.shift);
          efet_prev.push(0);
          efet_real.push(0);
          pres_prev.push(0);
        }
      });
      data2.data.forEach((item, index) => {
        let t1 = 0;
        let t2 = 0;
        let t3 = 0;
        let t3d = 0;
        item.tasks.forEach((item2, idex) => {
          if (item2.activity_type == 6) {
            if (item2.shift == 10) {
              let idx = legends.indexOf("Turno 1");
              efet_prev[idx] += 1;
              t1 = 1;
            }
            if (item2.shift == 12) {
              let idx = legends.indexOf("Turno 3");
              efet_prev[idx] += 1;
              t3 = 1;
            }
            if (item2.shift == 16) {
              let idx = legends.indexOf("Turno 2");
              efet_prev[idx] += 1;
              t2 = 1;
            }
            if (item2.shift == 13) {
              let idx = legends.indexOf("Turno 3 - D");
              efet_prev[idx] += 1;
              t3d = 1;
            }
          }
        });

        let exist_t1 = legends.includes("Turno 1");
        if (exist_t1) {
          let idx = legends.indexOf("Turno 1");
          pres_prev[idx] += t1;
        }

        let exist_t2 = legends.includes("Turno 2");
        if (exist_t2) {
          let idx = legends.indexOf("Turno 2");
          pres_prev[idx] += t2;
        }

        let exist_t3 = legends.includes("Turno 3");
        if (exist_t3) {
          let idx = legends.indexOf("Turno 3");
          pres_prev[idx] += t3;
        }

        let exist_t3d = legends.includes("Turno 3 - D");
        if (exist_t3d) {
          let idx = legends.indexOf("Turno 3 - D");
          pres_prev[idx] += t3d;
        }
      });
      legends.forEach((item, index) => {
        series[0].data.push(0);
        series[1].data.push(0);
        series[2].data.push(0);
        series[3].data.push(0);
        series[4].data.push(83);
      });

      //PRESENTEISMO
      data.data.forEach((item, index) => {
        let idx = legends.indexOf(item.shift);
        series[0].data[idx] += 1;
      });

      //HORA DIRETA
      data.data.forEach((item, index) => {
        let idx = legends.indexOf(item.shift);
        let transito = item.soma_transito ? item.soma_transito : 0;
        let doca = item.soma_doca ? item.soma_doca : 0;
        let arranque = item.soma_arranque ? item.soma_arranque : 0;
        let fechamento = item.soma_fechamento ? item.soma_fechamento : 0;
        let soma_ocorrencia = 0;
        //TEMPO OCORRENCIA
        if (item.jornada.tasks) {
          item.jornada.tasks.forEach((task, index) => {
            if (task.issues[0] && task.issues[0].finish_at) {
              let occurrence_total = 0;
              task.issues.forEach((item2, index) => {
                if (task.issues[index].finish_at) {
                  const aux = moment(task.issues[index].finish_at, "YYYY-MM-DD HH:mm:ss").diff(moment(task.issues[index].created_at, "YYYY-MM-DD HH:mm:ss"), "seconds");
                  occurrence_total += aux;
                }

              })
              soma_ocorrencia += occurrence_total;
            }
          });
        }
        series[1].data[idx] +=
          (transito + doca + arranque + fechamento - soma_ocorrencia);
      });

      //EFETIVIDADE
      data.data.forEach((item, index) => {
        let idx = legends.indexOf(item.shift);
        let dock_total = 0;
        if (item.jornada.tasks) {
          item.jornada.tasks.forEach((task, index2) => {
            if (task.activity_type == 6 && task.end_real != null) {
              dock_total += 1;
            }
          });
        }
        series[2].data[idx] += dock_total;
      });

      //CUBO
      series[3].data.forEach((item, index) => {
        let shift = legends[index];
        let hd_prev = 0;
        let hd_sum = series[1].data[index];
        if (shift == "Turno 1") hd_prev = 26160 * series[0].data[index];
        if (shift == "Turno 2") hd_prev = 24780 * series[0].data[index];
        if (shift == "Turno 3") hd_prev = 13800 * series[0].data[index];
        if (shift == "Turno 3 - D") hd_prev = 25980 * series[0].data[index];
        let percent_hd = (hd_sum * 85) / hd_prev;
        let percent_efet = (series[2].data[index] * 100) / efet_prev[index];
        let percent_presenteeism =
          (series[0].data[index] * 100) / pres_prev[index];
        series[3].data[index] =
          (percent_hd * percent_efet * percent_presenteeism) / 10000;
      });
      //console.log('Series: ', series)
      /*  //ARREDONDADO HD
       series[1].data.forEach((item, index) => {
         series[1].data[index] = Math.floor(item);
       }); */

      setState((prev) => ({
        ...prev,
        cube_shift: series,
        legends: legends,
      }));
    } catch (error) {
      console.warn(error);
    }
  }

  const handleDate = (date) => {
    setState((prev) => ({
      ...prev,
      start_day: moment(date).format("YYYY-MM-DD"),
      end_day: moment(date).add(1, "days").format("YYYY-MM-DD"),
    }));
  };
  return (
    <Card className={classes.root}>
      <CardContent>
        <Grid container justify="space-between" alignItems="center" spacing={3}>
          <Grid item lg={10} md={10} sm={10} xs={10}>
            <Typography>Cubo X Turno</Typography>
          </Grid>
          <Grid item lg={2} sm={2} md={2} xs={2}>
            <div style={{ marginTop: 10, marginBottom: 0 }}>
              <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBRLocale}>
                <ThemeProvider theme={fcaTheme}>
                  <KeyboardDatePicker
                    label="Filtro de Data"
                    disableFuture={true}
                    inputVariant="outlined"
                    disableToolbar
                    clearable="true"
                    autoOk={true}
                    style={{ paddingBottom: 12 }}
                    format="dd/MM/yyyy"
                    variant="inline"
                    value={moment(state.start_day, "YYYY-MM-DD")}
                    onChange={handleDate}
                  />
                </ThemeProvider>
              </MuiPickersUtilsProvider>
            </div>
          </Grid>
        </Grid>

        <GraphCard cube_shift={state.cube_shift} legends={state.legends} />
      </CardContent>
      <CardActions></CardActions>
    </Card>
  );
}

export default CuboXTurno;
